import { baseUrl } from "../../variables";
import { ICmExternalConnectionT2Detail } from "../types";


export const fetchCmExtConnT2Detail = async (id: number, contractType: string): Promise<ICmExternalConnectionT2Detail[] | null> => {
    try {              
        const response = await fetch(baseUrl + `/${contractType}/CmExternalConnectionT2?id=${id}`);
        if(!response.ok) {
            return null;
        }
        const data = await response.json();
        return data;

    } catch (error) {
        throw error;
    }
}

export const updateCmExtConnT2Detail = async(formData: ICmExternalConnectionT2Detail, contractType: string): Promise<void> => {
    try {
        const response = await fetch(baseUrl + `/${contractType}/CmExternalConnectionT2/${formData.id}`, {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(formData)
        });
        if (response.status !== 204) {
            throw new Error(`Request failed with status ${response.status}`);
        }

    } catch (error) {
        throw error;
    }
}